import { useEffect } from 'react';

/**
 * Full screen on this device (Mike, 18.10.: "Gerade im Ruhemodus macht der Vollbildmodus am
 * meisten Sinn"): hides Android's status and gesture bars on the wall tablet. Browsers allow it
 * only right after a touch, so the app asks on the next tap and stays there – rest screen and
 * night included. Swiping in from the edge leaves it; the next tap brings it back.
 */
const KEY = 'shh.fullscreen';
const CHANGED = 'shh:fullscreen';

/** Not every browser can (iPhone Safari cannot) – the setting only shows where it works. */
export const canFullscreen = () =>
  typeof document !== 'undefined' && Boolean(document.fullscreenEnabled);

export function getFullscreen(): boolean {
  try {
    return localStorage.getItem(KEY) === 'on';
  } catch {
    return false;
  }
}

const enter = () => {
  if (!document.fullscreenElement)
    void document.documentElement.requestFullscreen({ navigationUI: 'hide' }).catch(() => {});
};

/** Called from the settings – the tap on "An" is the touch the browser needs. */
export function setFullscreen(on: boolean) {
  try {
    if (on) localStorage.setItem(KEY, 'on');
    else localStorage.removeItem(KEY);
  } catch {
    // private mode: only for this visit
  }
  if (on) enter();
  else if (document.fullscreenElement) void document.exitFullscreen().catch(() => {});
  window.dispatchEvent(new Event(CHANGED));
}

/** In the app shell: with the setting on, every tap that finds the app windowed goes full screen. */
export function useFullscreen() {
  useEffect(() => {
    if (!canFullscreen()) return;
    let on = getFullscreen();
    const tap = () => {
      if (on) enter();
    };
    const changed = () => (on = getFullscreen());
    window.addEventListener('pointerup', tap, true);
    window.addEventListener(CHANGED, changed);
    return () => {
      window.removeEventListener('pointerup', tap, true);
      window.removeEventListener(CHANGED, changed);
    };
  }, []);
}
